import { render, staticRenderFns } from "./form-break.vue?vue&type=template&id=1fe1d153&scoped=true"
import script from "./form-break.ts?vue&type=script&lang=ts&external"
export * from "./form-break.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe1d153",
  null
  
)

export default component.exports